{
  "pt": {
    "todo": {
      "actions": {
        "add": "Adicionar tarefa",
        "cancel": "Cancelar",
        "delete_todo": "Eliminar tarefa",
        "edit": "Editar tarefa",
        "save": "Guardar"
      },
      "attributes": {
        "active": "Ativo",
        "assignee": "Responsável",
        "completed": "Concluído",
        "description": "Descrição",
        "due_date": "Prazo",
        "title": "Título"
      },
      "labels": {
        "active": "ativo",
        "allDone": "Todas as tarefas estão concluídas!",
        "allTodos": "Todas as tarefas",
        "completed": "concluído",
        "filterTodos": "Filtrar tarefas",
        "filters": "Filtros",
        "myTodos": "As minhas tarefas (versão antiga)",
        "myTodosCount": "As minhas tarefas ({count})",
        "noActiveTodos": "Não há tarefas ativas",
        "noActiveTodosDashboard": "Parabéns, não tem tarefas em aberto!",
        "noCompletedYet": "Ainda não há tarefas concluídas.",
        "noTodosCustomer": "Ótimo! Não tem nenhuma tarefa em aberto.",
        "selectAProjectFirst": "Selecionar primeiro um projeto",
        "showLess": "Mostrar menos",
        "showOthers": "Mostrar mais | Mostrar mais ({count})"
      },
      "toasts": {
        "create": "Tarefa criada",
        "delete": "Tarefa eliminada",
        "update": "Tarefa atualizada"
      },
      "validation": {
        "needtitle": "Título é obrigatório"
      }
    }
  }
}
